import { FormControl as FormControlComponent, FormControlGroup, FormControlLabel } from "./FormControl";

export const FormControl = Object.assign(FormControlComponent, {
  Label: FormControlLabel,
  Group: FormControlGroup
});